var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleminus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1028_3328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.043 0C5.00113 0 0 4.9152 0 10.957C0 16.9989 5.00113 22 11.043 22C17.0848 22 22 16.9989 22 10.957C22 4.9152 17.0848 0 11.043 0ZM16.8438 12.2461H5.15625C4.44555 12.2461 3.86719 11.6677 3.86719 10.957C3.86719 10.2463 4.44555 9.66797 5.15625 9.66797H16.8438C17.554 9.66797 18.1328 10.2463 18.1328 10.957C18.1328 11.6677 17.554 12.2461 16.8438 12.2461Z",
    fill: "#D8D8D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1028_3328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleminus);
export default __webpack_public_path__ + "static/media/circleminus.23036fbf7505231d712d36619c8cd523.svg";
export { ForwardRef as ReactComponent };